import * as yup from "yup";

export const validationSchema = yup.object({
  cnic: yup.string().required().min(5, "Must be more than 5"),
  instituteName: yup.string().required("Institute Name is required"),
  instituteAddress: yup.string().required("Institute Address is required"),
  promoCode: yup.string(),
});
